module.exports = __webpack_public_path__ + "img/three1Blue.b00b0a2d.jpg";